var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCurrencySymbolCn = function SvgIconCurrencySymbolCn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3.648.547 3.895 9.102-2.208 1.483L.341.547zm2.377 9.051L9.895.547h3.307L8.199 11.132zm2.276-.784V18H5.165V8.814zm3.58.29v1.917H1.415V9.104zm0 3.375v1.917H1.415V12.48z"
  })));
};
export default SvgIconCurrencySymbolCn;